<div class="evida-banner p-medium rounded flex" [ngClass]="themeClass">
    @if (!noIcon) {
        <div class="evida-banner-icon">
            <mat-icon [svgIcon]="icon"></mat-icon>
        </div>
    }
    <div class="evida-banner-content w-full">
        <ng-content></ng-content>
    </div>
</div>
